/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvitationItem } from './InvitationItem';
import {
    InvitationItemFromJSON,
    InvitationItemFromJSONTyped,
    InvitationItemToJSON,
    InvitationItemToJSONTyped,
} from './InvitationItem';

/**
 * List of team invitations
 * @export
 * @interface InvitationsListResponse
 */
export interface InvitationsListResponse {
    /**
     * 
     * @type {Array<InvitationItem>}
     * @memberof InvitationsListResponse
     */
    invitations: Array<InvitationItem>;
    /**
     * 
     * @type {number}
     * @memberof InvitationsListResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof InvitationsListResponse
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof InvitationsListResponse
     */
    offset: number;
}

/**
 * Check if a given object implements the InvitationsListResponse interface.
 */
export function instanceOfInvitationsListResponse(value: object): value is InvitationsListResponse {
    if (!('invitations' in value) || value['invitations'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function InvitationsListResponseFromJSON(json: any): InvitationsListResponse {
    return InvitationsListResponseFromJSONTyped(json, false);
}

export function InvitationsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitations': ((json['invitations'] as Array<any>).map(InvitationItemFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function InvitationsListResponseToJSON(json: any): InvitationsListResponse {
    return InvitationsListResponseToJSONTyped(json, false);
}

export function InvitationsListResponseToJSONTyped(value?: InvitationsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitations': ((value['invitations'] as Array<any>).map(InvitationItemToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

